import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionClassTypeForm from '../../../components/forms/CompetitionClassTypeForm';
import { useCompetitionClassTypeApi } from '../../../hooks/useCompetitionClassTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CompetitionClassTypeDTO } from '../../../services/apiClient';

const CompetitionClassTypeEdit: React.FC = () => {
  const { getById, edit, isLoading } = useCompetitionClassTypeApi();
  const [entityData, setEntityData] = useState<CompetitionClassTypeDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Class Types', href: '/admin/competitionclasstypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching CompetitionClassType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/competitionclasstypes');
    } catch (error) {
      console.error('Error updating CompetitionClassType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionclasstypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.CompetitionClassType.Edit'
    >
        {entityData ? (
          <CompetitionClassTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/competitionclasstypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default CompetitionClassTypeEdit;